import request from '@/utils/zsm-requets'
import {BOOK} from "../base";
// 小红书商品相关
const good = BOOK + 'good/'
// 小红书类目相关
const category = BOOK + 'category/'

/**
 * 获取末级分类
 * @returns
 */
export function getClassifyList() {
  return request({
    url: category + 'getClassifyList',
    method: 'get'
  })
}

/**
 * 修改商品上下架
 * @param {String} id 商品Id
 * @param {String} shelfFlag 上下架标记
 * @returns
 */
export function listingDelisting(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: good + 'listingDelisting',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 创建商品
 * @param id 商品ID
 * @param loginCode 讲师账号
 * @param name 商品名称
 * @param price 价格
 * @param categoryId 类目ID
 * @param categoryName 类目名称
 * @param shippingTemplateId 物流模板Id
 * @param shippingTemplateName 商品主图
 * @param cover 物流模板Id
 * @param coverList 商品主图
 * @param content 商品主图
 * @param deliveryMode 物流模式,0：普通，1：支持无物流发货
 * @param freerReturn 是否支持7天无理由,1：支持，2：不支持
 * @param stockNum 库存
 * @returns
 */
export function createBookGood(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: good + 'createBookGood',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 修改商品
 * @extends createBookGood
 * @returns
 */
export function updateBookGood(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: good + 'updateBookGood',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 删除商品
 * @param id 商品Id
 * @returns
 */
export function deleteGood(id) {
  return request({
    url: good + 'deleteGood',
    method: 'get',
    params: {
      id
    }
  })
}

/**
 * 获取商品
 * @extends createBookGood
 * @param {Object} params 参数(参加创建的参数)
 * @returns
 */
export function findBookGood(params) {
  return request({
    url: good + 'findBookGood',
    method: 'post',
    params
  })
}

/**
 * 获取商品详情
 * @param {String} id  商品Id
 * @returns
 */
export function getBookGoodById(id) {
  return request({
    url: good + 'getBookGoodById',
    method: 'get',
    params: {
      id
    }
  })
}
